module.exports = __webpack_public_path__ + "static/web_animated-16e8f547f8bf9f6f27e9698aa4cf3ba7.svg";